import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Capacitor } from '@capacitor/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class OidcAuthGuard implements CanActivate {
  constructor(private oauth: OAuthService, private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Standalone, jelszavas helyi belépéssel: érvényes helyi token kell, különben /login.
    if (this.auth.isStandaloneLogin()) {
      return this.auth.hasValidLocalToken() ? true : this.router.createUrlTree(['/login']);
    }

    // Standalone, jelszó nélkül (fix user): mindig engedjük.
    if (this.auth.isStandalone()) {
      return true;
    }

    if (this.oauth.hasValidAccessToken()) {
      return true;
    }

    // Natív, több-intézményes belépés: OAuth ELŐTT ki kell választani, MELYIK intézmény IdP-jéhez
    // lépünk be (minden intézmény külön deploy = külön IdP). Ha még nincs választott intézmény → választó.
    if (Capacitor.isNativePlatform() && !this.auth.hasChosenInstitution()) {
      return this.router.createUrlTree(['/intezmeny-belepo']);
    }

    // start code flow (Capacitor Browser via your openUri)
    this.auth.login();

    // cancel navigation for now
    return false;
  }
}
